/* eslint-disable react-hooks/exhaustive-deps */
import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import IconButton from "../../common/IconButton";
import Table from "../../common/Table";
import Body from "../../components/Body";
import { BiPlus } from "react-icons/bi";
import { FaSignature } from "react-icons/fa";
import { MdGroupWork } from "react-icons/md";
import { AiOutlineExclamationCircle } from "react-icons/ai";
import { LiaMoneyCheckAltSolid } from "react-icons/lia";
import AppButton from "../../common/AppButton";
import TableMenu from "../../components/TableMenu";
import AppModal from "../../common/AppModal";

import useHeader from "../../hooks/useHeader";
import OrganizationShowModel from "./OrganizationShowModel";
import OrganizationCreateModel from "./OrganizationCreateModel";
import { cloneDeep } from "lodash";
import { useNavigate } from "react-router-dom";
import { getOrganizations } from "../../stores/OrganizationStore";
import { useQuery } from "@tanstack/react-query";
import BulkPaymentModel from "./BulkPaymentModel";

const header = [
  // {
  //   name: "organizationId",
  //   title: "Client ID",
  //   filter: "Search",
  // },
  {
    title: "Clients",
    name: "name",
    filter: "Search",
    trunecate: true,
    style: { width: 600, textAlign: "left", trunecate: true },
  },
  {
    title: "Phone",
    name: "phone",
    style: { textAlign: "left" },
  },
  {
    title: "Email",
    name: "email",
    style: { width: 300, textAlign: "left" },
  },
];

function Organization() {
  const navigate = useNavigate();
  const { setHeader } = useHeader();

  const { data } = useQuery({
    queryFn: () => getOrganizations(),
    queryKey: ["organizations"],
  });

  const [model, setModel] = useState({
    visible: false,
  });
  useEffect(() => {
    setHeader("Clients");
    // load();
  }, []);

  const handleView = (data) => {
    navigate(`/organizations/view/${data?._id}`, {
      state: { data: cloneDeep(data) },
    });
  };
  const openContracts = (data) => {
    navigate(`/organizations/contracts/${data?._id}`, {
      state: { data: cloneDeep(data) },
    });
  };

  const Org = OrganizationShowModel();
  const newOrg = OrganizationCreateModel();
  const paymentModel = BulkPaymentModel();
  return (
    <Body noPadding>
      <TableMenu>
        <IconButton
          onClick={() => {
            setModel({
              visible: true,
              // header: <newOrg.Header />,
              model: (
                <newOrg.Body
                  onDone={() => {
                    setModel({});
                  }}
                />
              ),
              // footer: <newOrg.Footer />,
            });
          }}
          icon={<BiPlus size={35} />}
        />
      </TableMenu>
      <Table
        sortable
        header={header}
        data={data?.map((dt, ind) => {
          return { ...dt, style: (ind === 0) & { minWidth: 600 } };
        })}
        SideButtons={({ inv }) => {
          return (
            <div className="side-button">
              <AppButton
                onClick={() => openContracts(inv)}
                leftIcon={<FaSignature size={22} />}
                tooltip="Contracts"
                className="text-primary btn-light"
              />
              <AppButton
                onClick={() => handleView(inv)}
                leftIcon={<MdGroupWork size={22} />}
                tooltip="Jobs"
                className="text-primary btn-light"
              />
              <AppButton
                leftIcon={<LiaMoneyCheckAltSolid size={22} />}
                tooltip="Add Payments"
                className="text-primary btn-light"
                onClick={() => {
                  setModel({
                    visible: true,
                    model: (
                      <paymentModel.Body
                        onDone={() => {
                          setModel({});
                        }}
                      />
                    ),
                  });
                }}
              />
              <AppButton
                tooltip="Client's Details"
                onClick={() => {
                  setModel({
                    visible: true,
                    // header: <Org.Header organization={init} />,
                    model: (
                      <Org.Body
                        organization={inv}
                        onDone={() => {
                          setModel({});
                        }}
                      />
                    ),
                    // footer: <Org.Footer organization={init} />,
                  });
                }}
                leftIcon={<AiOutlineExclamationCircle size={24} />}
                className="text-primary btn-light"
              />
            </div>
          );
        }}
      />

      <AppModal
        {...model}
        onHide={() => {
          setModel({});
        }}
      />
      {/* <AppModal
        onHide={() => {
          setModel({ visible: false });
          setForm(cloneDeep(formInit));
        }}
        header={<OrganizationCreateModel.Header />}
        body={<OrganizationCreateModel.Body form={form} setForm={setForm} />}
        footer={
          <OrganizationCreateModel.Footer
            onClick={(event) => {
              handleSubmit(event);
            }}
          />
        }
        visible={model.visible}
      /> */}
    </Body>
  );
}
export default observer(Organization);
